import { BaseWebComponentView } from '../../../../../framework/BaseWebComponentView';
import { IntegrityMonitorCustomRuleActionsFormWebComponent } from '../../imCustomRuleActionsForm';
import { WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_ACTIONS_FORM } from '../../../../../webcomponents.constants';
import {
  getIntegrityMonitorOsTypes,
  getIntegrityMonitorRulesDirectoryAttributes,
  IntegrityMonitorPlatform,
} from '../../../../common/utils/types';
import { GzTitleWebComponent } from '../../../../../ui/gzTitle';
import { FormGroup } from '../../../../../ui/gzForm/formGroup/form-group';
import { GzFormFieldWebComponent } from '../../../../../ui/gzForm/formField';
import { GzDropdownWebComponent } from '../../../../../ui/gzDropdown';
import { RequiredValidator } from '../../../../../ui/gzForm/validators/required.validator';
import { CustomRuleValidators } from '../../common/validators';
import { IMConstants } from '../../../../common/utils/IMConstants';
import {
  DirectoryPathItem,
  IntegrityMonitorDirectoryPathFormFieldWebComponent,
} from '../../imCustomRuleDirectoryPathFormField/IntegrityMonitorDirectoryPathFormFieldWebComponent';

export class IntegrityMonitorDirectoryRuleFormView extends BaseWebComponentView {
  public formGroup: FormGroup;

  public dom: {
    $securitySubtitle: GzTitleWebComponent;

    $osFormField: GzFormFieldWebComponent<GzDropdownWebComponent, string | number>;
    $pathFormField: GzFormFieldWebComponent<IntegrityMonitorDirectoryPathFormFieldWebComponent, DirectoryPathItem[]>;

    $actionsForm: IntegrityMonitorCustomRuleActionsFormWebComponent;
  };

  getDomElements() {
    this.dom = {
      $securitySubtitle: this.shadow.querySelector('#security-subtitle'),

      $osFormField: this.shadow.querySelector('#os-form-field'),
      $pathFormField: this.shadow.querySelector('#path-form-field'),

      $actionsForm: this.shadow.querySelector(WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_ACTIONS_FORM),
    };

    this.getTranslations();
    this.setTranslatedStrings();
    this.createFormGroup();
  }

  getTranslations() {
    this.commonStrings = this.stringsTranslator.getCommonStrings();
    this.translations = this.stringsTranslator.getIntegrityMonitorStrings().integrityMonitorRules.customRuleForm;
  }

  setTranslatedStrings() {
    this.dom.$securitySubtitle.innerText = this.translations.securitySubtitle;

    this.dom.$osFormField.label = this.translations.osLabel;
    this.dom.$osFormField.Input.placeholder = this.translations.osPlaceholder;

    this.dom.$pathFormField.label = this.translations.entityTypeDirectory.pathLabel;
    this.dom.$pathFormField.Input.placeholder = this.translations.entityTypeDirectory.pathPlaceholder;
    this.dom.$pathFormField.Input.checkboxLabel = this.translations.entityTypeDirectory.includeSubdirectories;
  }

  initEnumFilter() {
    this.dom.$osFormField.Input.options = getIntegrityMonitorOsTypes(this.dependencies.translateFn)
      .filter(os => os.implemented)
      .map(os => {
        return {
          title: os.label,
          value: os.value,
        };
      });
  }

  createFormGroup() {
    this.dom.$osFormField.Validators = [RequiredValidator(this.commonStrings.requiredField)];
    this.dom.$pathFormField.Validators = [
      CustomRuleValidators.atLeastOneValidator(this.translations.entityTypeDirectory.errorAtLeastOnePath),
      CustomRuleValidators.atMostValidator(
        IMConstants.INTEGRITY_MONITOR_RULE_DIRECTORY_MAX_ALLOWED_PATHS,
        this.translations.entityTypeDirectory.errorTooManyPaths
      ),
    ];

    this.dom.$pathFormField.Input.maxValues = IMConstants.INTEGRITY_MONITOR_RULE_DIRECTORY_MAX_ALLOWED_PATHS;

    this.dom.$pathFormField.Input.validator = CustomRuleValidators.pathValidator(
      () => this.dom.$osFormField.value as IntegrityMonitorPlatform,
      true,
      true,
      this.translations.validationErrors
    );

    this.dom.$pathFormField.Input.translations = this.translations.validationErrors;

    this.dom.$osFormField.initialValue = '';
    this.dom.$pathFormField.initialValue = [];

    this.formGroup = FormGroup.build({
      os: this.dom.$osFormField,
      keys: this.dom.$pathFormField,
    });
  }

  buildSuccessView(data: any) {
    this.dom.$actionsForm.injectDependencies(this.dependencies);
    this.dom.$actionsForm
      .start()
      .catch(console.warn)
      .then(() => {
        this.dom.$actionsForm.options = getIntegrityMonitorRulesDirectoryAttributes(this.dependencies.translateFn);
        this.formGroup.addFormChild(['attributes'], this.dom.$actionsForm.controller.view.formGroup);
      });

    this.initEnumFilter();
  }
}
